import { render, staticRenderFns } from "./AdminMainList.vue?vue&type=template&id=f2e7e70a&scoped=true&"
import script from "./AdminMainList.vue?vue&type=script&lang=js&"
export * from "./AdminMainList.vue?vue&type=script&lang=js&"
import style0 from "./AdminMainList.vue?vue&type=style&index=0&id=f2e7e70a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e7e70a",
  null
  
)

export default component.exports